<template>
    <div v-if="modelValue" class="custom-dialog-overlay">
        <div class="custom-dialog">
            <div class="dialog-header">
                <span class="icon">🔔</span>
                <h2>Enable Notifications?</h2>
            </div>
            <p class="dialog-text">
                Stay updated with important alerts, announcements, and reminders from your workspace.
            </p>
            <div class="dialog-actions">
                <button class="btn cancel" @click="$emit('update:modelValue', false)">No Thanks</button>
                <button class="btn confirm" @click="handleConfirm">Yes, Enable</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { requestNotificationPermission, setupForegroundListener } from '@/FirebaseMessagingService'

defineProps({
    modelValue: Boolean,
})

const emit = defineEmits(['update:modelValue'])

const handleConfirm = async () => {
    emit('update:modelValue', false)
    await requestNotificationPermission()
    await setupForegroundListener()
}
</script>

<style scoped>
.custom-dialog-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.custom-dialog {
    background: #fff;
    border-radius: 16px;
    padding: 24px;
    max-width: 400px;
    width: 90%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    animation: fadeIn 0.3s ease;
}

.dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}

.dialog-header .icon {
    font-size: 24px;
}

.dialog-text {
    color: #555;
    margin-bottom: 24px;
}

.dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn {
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.2s ease;
}

.btn.cancel {
    background: #e0e0e0;
    color: #333;
}

.btn.confirm {
    background: #1976d2;
    color: #fff;
}

.btn:hover {
    opacity: 0.9;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.96);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}
</style>
